export default "__VITE_ASSET__CLwZgpUU__"